/** The creator-sheet import's limits, each mirroring a backend constant
 *  (internal/limits/limits.go, import_field_list.go). The server is the judge;
 *  these keep the wizard's wording and its early checks reading from one
 *  place, so a changed limit can't leave the hint, the Sheet rules text and
 *  the check disagreeing. */
import type { ImportTarget } from '@discovr/types';

const BYTES_PER_MEGABYTE = 1024 * 1024;
const LIMIT_NUMBER_LOCALE = 'en-US';

export const MAX_SHEET_MEGABYTES = 5;
export const MAX_SHEET_BYTES = MAX_SHEET_MEGABYTES * BYTES_PER_MEGABYTE;
/** Data rows, the header row not counted. */
export const MAX_SHEET_ROWS = 5000;
/** An outreach import's own cap (limits.MaxOutreachImportRows). */
export const MAX_OUTREACH_ROWS = 2000;
export const MAX_ROWS_BY_TARGET: Record<ImportTarget, number> = {
  pipeline: MAX_SHEET_ROWS,
  outreach: MAX_OUTREACH_ROWS,
};
export const MIN_USAGE_RIGHTS_DAYS = 1;
export const MAX_USAGE_RIGHTS_DAYS = 3650;

/** A limit as the wizard prints it: 5000 -> "5,000". */
export function formatLimit(limit: number): string {
  return limit.toLocaleString(LIMIT_NUMBER_LOCALE);
}

export const MAX_SHEET_SIZE_LABEL = `${MAX_SHEET_MEGABYTES} MB`;
export const MAX_SHEET_ROWS_LABEL = formatLimit(MAX_SHEET_ROWS);
